// src/pages/Flights.tsx
import { useState, useEffect } from 'react';
import {
    Box,
    Button,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    useBreakpointValue,
    useDisclosure,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
} from '@chakra-ui/react';
import { getFlights, createFlight, deleteFlight } from '../../../services/travel/flightService';
import FlightForm from './FlightForm';

const cardsBorderRadii ="8px";

const Flights = () => {
    const [flights, setFlights] = useState<any[]>([]);
    const [selectedFlight, setSelectedFlight] = useState<any>(null);
    const { isOpen, onOpen, onClose } = useDisclosure();

    const tableSize = useBreakpointValue({ base: 'xs', md: 'sm' });
    const minTableWidth = useBreakpointValue({ base: '700px', md: 'auto' });

    const fetchFlights = async () => {
        const response = await getFlights();
        setFlights(response.data);
    };

    useEffect(() => {
        fetchFlights();
    }, []);

    const handleCreate = async (data: any) => {
        await createFlight(data);
        fetchFlights();
        onClose();
    };

    const handleUpdate = async (data: any) => {
        if (selectedFlight) {
            // await updateFlight(selectedFlight._id, data);
            fetchFlights();
            onClose();
        }
    };

    const handleDelete = async (id: string) => {
        await deleteFlight(id);
        fetchFlights();
    };

    return (
        <Box bg="white" borderRadius={cardsBorderRadii} boxShadow="md" minH="100vh">
            <Button size={'sm'} color={'#fff'} bg={'#252525'} m={4} borderRadius={cardsBorderRadii} onClick={() => { setSelectedFlight(null); onOpen(); }}>
                Add Flight
            </Button>

            <Box overflowX="auto">
                <Table variant="simple" size={tableSize} minW={minTableWidth} whiteSpace="nowrap">
                    <Thead>
                        <Tr borderTop={'1px solid #EDF2F7'} height="50px">
                            <Th px={{ base: 2, md: 4 }}>Airline</Th>
                            <Th px={{ base: 2, md: 4 }}>From</Th>
                            <Th px={{ base: 2, md: 4 }}>To</Th>
                            <Th px={{ base: 2, md: 4 }}>Departure</Th>
                            <Th px={{ base: 2, md: 4 }}>Return</Th>
                            <Th px={{ base: 2, md: 4 }}>Price</Th>
                            <Th px={{ base: 2, md: 4 }}>Passengers</Th>
                            <Th px={{ base: 2, md: 4 }}>Class</Th>
                            <Th px={{ base: 2, md: 4 }}>Actions</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {flights.map((flight, idx) => (
                            <Tr
                                key={flight._id}
                                bg={idx % 2 === 0 ? 'gray.50' : 'white'}
                                height="50px"
                            >
                                <Td px={{ base: 2, md: 4 }} fontSize={{ base: 'xs', md: 'sm' }}>
                                    {flight.airline}
                                </Td>
                                <Td px={{ base: 2, md: 4 }} fontSize={{ base: 'xs', md: 'sm' }}>
                                    {flight.from}
                                </Td>
                                <Td px={{ base: 2, md: 4 }} fontSize={{ base: 'xs', md: 'sm' }}>
                                    {flight.to}
                                </Td>
                                <Td px={{ base: 2, md: 4 }} fontSize={{ base: 'xs', md: 'sm' }}>
                                    {flight.departureDate}
                                </Td>
                                <Td px={{ base: 2, md: 4 }} fontSize={{ base: 'xs', md: 'sm' }}>
                                    {flight.returnDate}
                                </Td>
                                <Td px={{ base: 2, md: 4 }} fontSize={{ base: 'xs', md: 'sm' }} fontWeight="bold">
                                    {flight.price}
                                </Td>
                                <Td px={{ base: 2, md: 4 }} fontSize={{ base: 'xs', md: 'sm' }}>
                                    {flight.passengers}
                                </Td>
                                <Td px={{ base: 2, md: 4 }} fontSize={{ base: 'xs', md: 'sm' }}>
                                    {flight.class}
                                </Td>
                                <Td px={{ base: 2, md: 4 }}>
                                    <Button
                                        size="xs"
                                        mr={2}
                                        onClick={() => { setSelectedFlight(flight); onOpen(); }}
                                    >
                                        Edit
                                    </Button>
                                    <Button
                                        size="xs"
                                        colorScheme="red"
                                        onClick={() => handleDelete(flight._id)}
                                    >
                                        Delete
                                    </Button>
                                </Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </Box>

            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        {selectedFlight ? 'Edit Flight' : 'Add Flight'}
                    </ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <FlightForm
                            initialData={selectedFlight}
                            onSubmit={selectedFlight ? handleUpdate : handleCreate}
                        />
                    </ModalBody>
                </ModalContent>
            </Modal>
        </Box>
    );
};

export default Flights;
